import axios from 'axios'
import vm from '../main'

const qs = require('qs')
const Http = axios

// 接口请求base地址
Http.defaults.baseURL = process.env.API_DOMAIN

// 接口超时时间设置
// Http.defaults.timeout = 1000 * 60

// 解决跨域后session失效
Http.defaults.withCredentials = true

// 请求拦截
Http.interceptors.request.use(
  config => {
    const method = config.method
    if (method === 'post' || method === 'put') {
      if (config.format && config.format === 'json') {
        config.headers['Content-Type'] = 'application/json'
      } else {
        config.data = qs.stringify(config.data)
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截
Http.interceptors.response.use(
  res => {
    if (String(res.data).includes(9001) === true) {
      let url = window.location.href
      if (url.includes('session') === false) {
        // 清除用户信息
        window.localStorage.removeItem('user')
        vm.$webSocket.close()
        vm.$router.push({path: '/login'})
        return []
      }
    } else if (res.data.result === 1) {
      // vm.$Message.warning(vm.$t('errException'))
      if (res.data.message) {
        vm.$Message.info({
          content: vm.$t('errException') + ': ' + res.data.message,
          duration: 10,
          closable: true
        })
      } else {
        vm.$Message.warning(vm.$t('errException'))
      }
      return res.data
    } else {
      return res.data
    }
  },
  error => {
    // 请求超时的之后，抛出 error.code = ECONNABORTED的错误..错误信息是 timeout of  xxx ms exceeded
    if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
      vm.$Message.warning(vm.$t('errTimeout'))
    }
  }
)

export default Http



// WEBPACK FOOTER //
// ./src/services/http.js